module.exports = __webpack_public_path__ + "static/media/4p.8a6aaeb9.png";